import ErrorFallback from 'Components/ErrorFallback'
import {
  CodespaceCreatePage,
  CodespaceEditPage,
  CodespaceListPage
} from 'Services/ControlDataManagement/Features/Codespace/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function CodespaceRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<CodespaceListPage />} />
        <Route path="create" element={<CodespaceCreatePage />} />
        <Route path=":id/edit" element={<CodespaceEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default CodespaceRoot
